
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Divider from 'vux/src/components/divider/index.vue'

import api from '../api/api';

export default {
components: {
Tab,
TabItem,
XInput,
Group,
XImg,
XButton,
CellBox,
GroupTitle,
Grid,
GridItem,
Divider,
},
data() {
return {
queryType: 0,
phoneNo: null,
orderNo: null,
sendSmsBtnDisabled: false,
sendSmsBtnText: '发送验证码',
smsCode: null,
orders: [],
showResult: false,
};
},
methods: {
queryOrders() {
this.$vux.loading.show({
text: '加载中',
});
const $this = this;
api.getOrders({
queryType: this.queryType === 0 ? 'order_no' : 'phone_no',
value: this.queryType === 0 ? this.orderNo : this.phoneNo,
smsCode: this.smsCode,
}).then((resp) => {
if(resp.data && resp.data.length === 1) {
const order = resp.data[0];
$this.$router.push({
name: 'OrderDetail',
params: {orderNo: order.orderNo}
});
return;
}
$this.orders = resp.data;
$this.showResult = true;
}).finally(() => {
$this.$vux.loading.hide();
});
},
sendSms() {
if (!this.phoneNo) {
return;
}
this.sendSmsBtnDisabled = true;
const $this = this;
api.sendSms(this.phoneNo).then(() => {
$this.startCountdown(30);
});
},
startCountdown(seconds) {
if (seconds === 0) {
this.sendSmsBtnText = '发送验证码';
this.sendSmsBtnDisabled = false;
return;
}
this.sendSmsBtnText = `${seconds} 秒`;
setTimeout(() => {
this.startCountdown(seconds - 1);
}, 1000);
},
},
};



// WEBPACK FOOTER //
// ./src/components/QueryIndex.vue